import { Helmet } from "react-helmet-async";
import { Hero } from "@/components/Hero";
import { About } from "@/components/About";
import { Offer } from "@/components/Offer";
import { Benefits } from "@/components/Benefits";
import { WhyUs } from "@/components/WhyUs";
import { FormsOfComedy } from "@/components/FormsOfComedy";
import { Testimonials } from "@/components/Testimonials";
import { ContactForm } from "@/components/ContactForm";
import { Navigation } from "@/components/Navigation";
import { Footer } from "@/components/Footer";
import { VideoSection } from "@/components/VideoSection";

const Index = () => {
  return (
    <div className="min-h-screen">
      <Helmet>
        <title>Występy dla firm - stand-up, kabaret, iluzja | WystepFirmowy.pl</title>
        <meta name="description" content="Profesjonalne występy artystyczne i komediowe dla firm. Stand-up, kabaret, iluzja i więcej. Ponad 999 zrealizowanych wydarzeń w całej Polsce." />
        <link rel="canonical" href="https://wystepfirmowy.pl/" />
      </Helmet>
      <Navigation />
      <main>
        <Hero />
        <About />
        <Offer />
        <Benefits />
        <WhyUs />
        <FormsOfComedy />
        <VideoSection />
        <Testimonials />
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
};

export default Index;